import axios from 'axios';

const axiosServices = axios.create({
	baseURL: `${process.env.REACT_APP_URL_API_V2}`
});

export default axiosServices;
